<div class="InputWithCounter">
  <mat-form-field class="InputWithCounter-input" [subscriptSizing]="'dynamic'">
    @if (label()) {
      <mat-label>{{ label() }}</mat-label>
    }
    <input
      #inputRef="ngModel"
      matInput
      autocomplete="off"
      list="autocompleteOff"
      [appAutoFocus]="autoFocus()"
      [required]="required()"
      (blur)="onBlur()"
      (focus)="onFocus()"
      [class]="className()"
      [placeholder]="placeholder()"
      [attr.maxlength]="maxLength()"
      [style.minHeight.px]="minHeight()"
      [attr.disabled]="disabled ? true : null"
      [disabled]="disabled"
      [ngModel]="value"
      (ngModelChange)="onChange($event)" />
    @if (iconClass() || iconName()) {
      <mat-icon matSuffix [class]="iconClass()">{{ iconName() }}</mat-icon>
    }
  </mat-form-field>

  <div class="InputWithCounter-subscript">
    <div class="InputWithCounter-subscriptStart">
      <ng-content select="mat-error" />
      <ng-content />
      @if (hint) {
        <span class="InputWithCounter-hintText">{{ hint }}</span>
      }
    </div>
    <div class="InputWithCounter-subscriptEnd">{{ counter }}/{{ maxLength() }}</div>
  </div>
</div>
